export enum TypeSuivi {
    'Téléphone' = 1 , 'Email', 'Entretien', 'Entretien sur site', 'Courrier', 'Autre'
}
